/**
 * Validate email
 *
 * @param {String} email
 *
 * @return {boolean}
 */
export function isEmailsValidation(email) {
    if(!email){
        return null;
    }
    //eslint-disable-next-line
    return /^((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})),?(\s)*)*$/.test(
        email.toLowerCase().trim()) ? null : 'validation.error.invalid_emails';
}



// WEBPACK FOOTER //
// ./src/utils/isEmailsValidation.js